import Calendar from 'react-calendar';
import * as dateUtils from '../../lib/dateutils';
import './OutlawCalendar.less';
import 'react-calendar/dist/Calendar.css';
import {useCallback} from "react";
import type {VoidCallback} from "../../@types/functions";
import Moment from "moment";

function OutlawCalendar(props: OutlawCalendarProps) {
    const calDate = props.defaultValue ?? new Date();

    /**
     * On calendar change, the date object will either be a single Moment (props.isRange false) or an array of Moments
     * @param {date | Array.<Date>} date
     * @param {MouseEvent} event
     */
    const onChange = useCallback((date: Date | Date[], event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        event.stopPropagation();

        if (props.onChange) props.onChange(date, props.onClose);
    }, [props]);

    /**
     * Function to format dates.  Calls a property if available
     *
     * @param {{date: Date}}
     * @returns {string}
     */
    const getDayClass = useCallback(({date}: { date: Date; }): string => {
        const mDate = dateUtils.toMoment(date);
        const mToday = dateUtils.toMoment(new Date());
        const mStartDate = props.startDate ? dateUtils.toMoment(props.startDate) : null;
        const mEndDate = props.endDate ? dateUtils.toMoment(props.endDate) : null;
        const today = mDate.isSame(mToday, 'date') ? 'OutlawCalendar-Today' : '';

        let selected = '';
        if (props.isRange && mDate.isBetween(mStartDate, mEndDate)) selected = 'OutlawCalendar-Selected';
        if (!props.isRange && dateUtils.isSame(mDate, mStartDate)) selected = 'OutlawCalendar-Selected';

        return ['OutlawCalendar-Tile', today, selected, props.getDayClass ? props.getDayClass(dateUtils.toMoment(date)) : ''].join(' ');
    }, [props]);

    /**
     * Move the range to today, but do NOT click
     */
    const onToday = () => {
        if (props.onChange) props.onChange(new Date());
    };

    return <div className='OutlawCalendar-Wrapper'
                style={{display: 'flex', flexDirection: 'column', height: '100%', width: '100%'}}
    >
        <Calendar className="OutlawCalendar"
                  onChange={onChange}
                  value={props.isRange ? props.startDate : calDate}
                  selectRange={props.isRange}
                  tileClassName={getDayClass}
                  showNeighboringMonth={true}
        />
        {!props.hideToday && <div className='OutlawCalendar__today' onClick={onToday}>Today</div>}
    </div>;
}

type OutlawCalendarState = {
    date: Date | Date[]
}

export type OutlawCalendarProps = {
    startDate?: Date,
    endDate?: Date,
    isRange?: boolean,
    onChange: (date: Date | Date[], onClose?: VoidCallback) => void,
    getDayClass?: (date: Moment.Moment) => string,
    dateFormat: string, // default is 'dd',
    hideToday?: boolean,
    defaultValue: Date | [Date, Date], // default is new Date
    onClose?: VoidCallback // passed in from dialogNoCancel
};

export default OutlawCalendar;
